export default __webpack_public_path__ + "static/121-min-min-6259cbf2a02ca736e9fdf5321b9fde46.jpg";